module.exports = __webpack_public_path__ + "img/四川天府新区煎茶小学校东区.65cee0ae.jpg";